module.exports = __webpack_public_path__ + "img/218M带纸顶.241.19f4e03e.png";